import { OnInit, OnDestroy } from '@angular/core';
import { InfoProfileService } from '../info-profile.service';
var UserPersonalInformationComponent = /** @class */ (function () {
    function UserPersonalInformationComponent(infoProfileService) {
        this.infoProfileService = infoProfileService;
    }
    UserPersonalInformationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userProfileSubscription = this.infoProfileService.getUserProfile().subscribe(function (userProfile) {
            if (userProfile) {
                _this.userName = _this.formatUserName(userProfile.userName);
                _this.userPicture = userProfile.userPicture;
            }
        });
    };
    UserPersonalInformationComponent.prototype.ngOnDestroy = function () {
        if (this.userProfileSubscription) {
            this.userProfileSubscription.unsubscribe();
        }
    };
    UserPersonalInformationComponent.prototype.formatUserName = function (fullName) {
        var result = fullName.split(' ');
        var firstName = result[0].trim();
        var lastName = '';
        if (result.length > 1)
            lastName = result.reverse()[0];
        return firstName + ' ' + lastName;
    };
    return UserPersonalInformationComponent;
}());
export { UserPersonalInformationComponent };
